import axios from './axios';
import { LocationGroupResponseTypes, ResponseTypes } from '../types/response';
import { GET_LOCATION_GROUPS_API } from '../commons/constants/apis';

export const getDetailGroupByKey = async (key: string, language: string): Promise<any> => {
  try {
    const resp: ResponseTypes<LocationGroupResponseTypes[]> = await axios.get(
      `${GET_LOCATION_GROUPS_API}/${key}`,
      {
        headers: { language },
      }
    );

    return resp.data;
  } catch (e) {
    return { notFound: true };
  }
};
